<template>
  <div class="carousel" v-loading="loading">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="search" placeholder="请输入标题" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
      <el-button type="primary" @click="handleAdd">新增</el-button>
    </div>

    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题"></el-table-column>
        <!-- <el-table-column prop="title" label="内容"></el-table-column> -->
        <el-table-column prop="sortNum" label="排序"></el-table-column>
        <el-table-column label="图片">
          <template slot-scope="scope">
            <span class="show_img" @click="previewImage(scope.row.carouselUrl)">查看图片</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="200">
          <template slot-scope="scope">
            <el-button class="btn" type="" plain @click="handleEdit(scope.row)">修改</el-button>
            <el-button class="btn" type="danger" plain @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-dialog :title="isAdd ? '新增' : '修改'" :visible.sync="dialogVisible" width="60%" :before-close="onCancel">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="ruleForm">
        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-form-item label="标题" prop="title">
              <el-input v-model="ruleForm.title" placeholder="请输入标题"></el-input>
            </el-form-item>
            <!-- <el-form-item label="是否绑定职位" prop="linkFlag">
              <el-select v-model="ruleForm.linkFlag" placeholder="请选择是否绑定职位">
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
              </el-select>
            </el-form-item> -->
          </el-col>
          <el-col :span="10">
            <el-form-item label="排序" prop="sortNum">
              <el-input v-model="ruleForm.sortNum" placeholder="请输入排序"></el-input>
            </el-form-item>
            <!-- <el-form-item label="绑定的职位" :prop="ruleForm.linkFlag == 1 ? 'positionId' : ''" v-if="ruleForm.linkFlag == 1">
              <el-select v-model="ruleForm.positionId" placeholder="请选择绑定的职位">
                <el-option v-for="(item, index) in options" :key="index" :label="item.positionName" :value="item.positionId"></el-option>
              </el-select>
            </el-form-item> -->
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="20">
            <el-form-item label="图片" prop="carouselUrl">
              <el-upload class="pic_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action" :show-file-list="false" :on-success="uploadSuccess('ruleForm', 'carouselUrl')" :before-upload="beforeUploads" :on-remove="() => onRemove('ruleForm', 'carouselUrl')" :disabled="ruleForm.carouselUrl ? true : false">
                <img v-if="ruleForm.carouselUrl" :src="ruleForm.carouselUrl" class="picurl" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <i v-if="ruleForm.carouselUrl" class="delpic_uploader el-icon-error" @click="() => onRemove('ruleForm', 'carouselUrl')"></i>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" :loading="btnloading">确 定</el-button>
      </span>
    </el-dialog>

    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false
        }
      "
      :url-list="imgList"
    ></el-image-viewer>
  </div>
</template>

<script>
function createForm() {
  return {
    title: "",
    sortNum: "",
    carouselUrl: "",
    // linkFlag: "", // 0否 1是
    // linkId: "", // 绑定的职位id
    // positionId: "", // 绑定的职位id（展示）
  }
}
export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      loading: false,
      btnloading: false,
      search: "",
      tableData: [],
      options: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
      dialogVisible: false,
      isAdd: true,

      showViewer: false,
      imgList: [],

      ruleForm: createForm(),
      rules: {
        title: [{ required: true, message: "请输入内容", trigger: "blur" }],
        sortNum: [{ required: true, message: "请输入内容", trigger: "blur" }],
        carouselUrl: [{ required: true, message: "请选择图片", trigger: "submit" }],
        // linkFlag: [{ required: true, message: "请选择内容", trigger: "change" }],
        // positionId: [{ required: true, message: "请选择内容", trigger: "change" }],
      },
      sortNum: "", // 修改时的排序

      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      this.$axios
        .get(this.$api.carouselInfoselect, {
          params: {
            title: this.search,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          this.tableData = res.result.list
          this.totalItemsCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getList()
    },
    // 修改（对话框）
    handleEdit(row) {
      this.isAdd = false
      this.ruleForm = Object.assign({}, row)
      this.sortNum = row.sortNum
      this.dialogVisible = true
    },
    // 删除
    handleDelete(row) {
      this.$confirm("即将删除该内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(`${this.$api.carouselInfodelete}/${row.id}`)
            .then(res => {
              this.$message.success("删除成功")
              this.getList()
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {})
    },
    // 文件上传前
    beforeUploads(file) {
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png"
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!")
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!")
      }
      return isJPG && isLt5M
    },
    // 删除图片
    onRemove(form, str) {
      this.$set(this[form], str, "")
    },
    // 上传成功
    uploadSuccess(form, str) {
      return (response, file, fileList) => {
        if (response.code == 100) {
          this.$set(this[form], str, response.result.fileUrl)
        } else {
          this.$message.error(response.desc)
        }
      }
    },
    handleAdd() {
      this.isAdd = true
      this.ruleForm = createForm()
      this.dialogVisible = true
    },
    submitForm() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.btnloading = true
          let api = ""
          let obj = Object.assign({}, this.ruleForm)
          // obj.linkId = obj.positionId
          // obj.contentType = 1
          if (this.isAdd) {
            api = this.$api.carouselInfoinsert
          } else {
            api = this.$api.carouselInfoupdate
            // obj.beforeSortNum = this.sortNum
          }
          this.$axios
            .post(api, obj)
            .then(res => {
              this.btnloading = false
              this.dialogVisible = false
              this.$message.success(`${this.isAdd ? "新增" : "修改"}成功`)
              this.getList()
            })
            .catch(err => {
              this.btnloading = false
              this.$message.error(err.desc)
            })
        }
      })
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getList()
    },
    // 关闭对话框
    onCancel() {
      this.ruleForm = createForm()
      this.dialogVisible = false
    },
    // 图片预览
    previewImage(url) {
      this.imgList = [url] || []
      this.showViewer = true
    },
  },
}
</script>

<style scoped lang="scss">
.carousel {
  .show_img {
    color: $themes;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }
  .pic_uploader {
    ::v-deep .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    ::v-deep .el-upload:hover {
      border-color: $themes;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: $themes;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }

    ::v-deep .el-upload--picture-card {
      background-color: #fff;
    }

    ::v-deep .el-upload-list__item-thumbnail {
      object-fit: cover;
    }

    .picurl {
      width: 100px;
      height: 100px;
      display: block;
      object-fit: cover;
    }
  }

  .delpic_uploader {
    position: absolute;
    top: -10px;
    left: 95px;
    color: red;
    font-size: 20px;
    cursor: pointer;
  }
}
</style>
